module.exports = __webpack_public_path__ + "media/images/social-linkedin-e7ea9ba20985830923f671bd48177935.svg";